<script setup lang="ts">
import type { Coverage, PaymentInfo } from '~/layers/forms/models/index'

interface props {
  coverage: Coverage
  paymentInfo: PaymentInfo
}

const props = defineProps<props>()

const { getTotalPayment, getPaymentInstallments, discountIsValid } = useCoveragePaymentSumary({
  amount: computed(() => props.coverage.grandTotal),
  discount: computed(() => props.paymentInfo),
  argentoInsurancePaymentCondition: computed(
    () =>
      props.coverage.argentoInsuranceAplicablePaymentConditions?.find(
        (aiapc) => aiapc.condicionPagoId === props.paymentInfo.argentoInsurancePaymentConditionId
      )?.condicionPago
  ),
  argentoInsuranceCalculatedPaymentConditions: computed(() =>
    props.coverage.argentoInsuranceAplicableCalculatedPaymentConditions?.find(
      (aiapc) => aiapc.condicionPagoId === props.paymentInfo.argentoInsurancePaymentConditionId
    )
  ),
})
</script>

<template>
  <FormsCoverageResume
    :coverage
    :payment-info
    :discount-amount="getTotalPayment({ applyDiscount: true })"
    :discount-tag="paymentInfo.discountTag"
    bg="light"
  />

  <CardComponent
    v-if="getPaymentInstallments()?.some((i) => i.order != 0)"
    bg="light"
  >
    <div class="p-4">
      <div class="pb-2 text-xl font-bold uppercase leading-none"> Desglose de cuotas </div>
      <div class="w-full grid grid-cols-2 gap-1">
        <PvDivider class="col-span-full my-1" />
        <div class="font-bold">Concepto</div>
        <div class="font-bold text-right">Monto</div>
        <PvDivider class="col-span-full my-1" />
        <template
          v-for="installment in getPaymentInstallments()"
          :key="installment"
        >
          <div class="text-xs flex items-center">{{ installment.name }}</div>

          <div class="flex flex-col items-end text-xs">
            <span class="font-bold">
              RD$
              {{
                formatCurrency({
                  price: discountIsValid ? (installment.discountedAmount ?? 0) : installment.amount,
                  fraction: true,
                })
              }}
            </span>
            <span
              v-if="discountIsValid"
              class="text-red-400 line-through text-xs leading-none"
            >
              RD$ {{ formatCurrency({ price: installment.amount, fraction: true }) }}
            </span>
          </div>
        </template>
      </div>
    </div>
  </CardComponent>
</template>
